import { useAppSelector } from "@/Hook/hooks";
import { IHelpHeader, IObjects } from "@/Redux/Ducks/dashboardSlice";
import { constant } from "@/Utils/constants";
import BaseMethods from "AlignBaseUI/BaseMethods";
import { Card, Table as BsTable, OverlayTrigger, Tooltip, Form } from "react-bootstrap";
import { BiLinkExternal } from "react-icons/bi";
import { GiMove } from "react-icons/gi";
// @ts-ignore
import Fade from 'react-reveal/Fade';

interface IProps {
	widgetno: string;
}

const Table = ({ widgetno }: IProps) => {
	const widget = useAppSelector(x => x.Dashboard.activeWidget.objects.find(x => x.widgetno == widgetno)) as IObjects;
	const dataFormat = useAppSelector(state => state.User.CompanyDataFormat);

	const routeToScreen = () => {

	}

	return (
		<div className="chart-card">
			<Fade>
				<Card>
					<Card.Header>
						{widget.widgetstxt}

						{
							widget.widgetprocesscode ? (
								<OverlayTrigger placement="bottom" overlay={<Tooltip>Hyperlink</Tooltip>}>
									<div className="hyperlink" onClick={() => { routeToScreen() }}>
										<BiLinkExternal size={12} />
									</div>
								</OverlayTrigger>
							) : null
						}
						<OverlayTrigger placement="bottom" overlay={<Tooltip>Move</Tooltip>}>
							<div className="drag-handle">
								<GiMove size={12} />
							</div>
						</OverlayTrigger>

					</Card.Header>
					<Card.Body>
						<BsTable hover>
							<thead>
								<tr>
									{
										widget.Header.map((col) => (
											<th
												key={col.ColumnID}
												style={{ whiteSpace: "nowrap" }}
											>
												{col.ColumnText}
											</th>
										))
									}
								</tr>
							</thead>
							<tbody>
								{
									widget.data.length >= 1 ?
										widget.data.map((row) => {
											return (
												<tr>
													{
														Object.entries(row).map(([colHeader, value], idx) => {
															let header = widget.Header.find(x => x.ColumnID == colHeader) as IHelpHeader;
															let binding = header.ColumnID;
															let format = null;

															if (BaseMethods.getControlType(header.controltype) == "checkbox") {
																return (
																	<td
																		key={binding}
																		style={{ whiteSpace: "nowrap" }}
																	>
																		<Form.Check // prettier-ignore
																			type="checkbox"
																			disabled={true}
																			checked={value}
																		/>
																	</td>
																)
															}
															else if (BaseMethods.getControlType(header.controltype) == "date") {
																format = constant.DefaultDateFormat;
																return (
																	<td
																		key={binding}
																	>
																		{BaseMethods.convertDateToCompanyFormat(value, format)}
																	</td>
																)
															}
															else if (BaseMethods.getControlType(header.controltype) == "time") {
																format = constant.DefaultTimeFormat;
																return (
																	<td
																		key={binding}
																	>
																		{BaseMethods.convertDateToCompanyFormat(value, format)}
																	</td>
																)
															}
															else {
																return (
																	<td
																		key={idx}
																	>
																		{value}
																	</td>
																)
															}
														})
													}
												</tr>
											)
										}) : null
								}
							</tbody>
						</BsTable>
					</Card.Body>
				</Card>
			</Fade>
		</div>
	)
}

export default Table;